import { render, staticRenderFns } from "./BasicSwitch.vue?vue&type=template&id=c6c609c8&scoped=true"
import script from "./BasicSwitch.vue?vue&type=script&lang=js"
export * from "./BasicSwitch.vue?vue&type=script&lang=js"
import style0 from "./BasicSwitch.vue?vue&type=style&index=0&id=c6c609c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c609c8",
  null
  
)

export default component.exports